import React, { useState } from "react";
import { X } from "lucide-react";

const FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black";
const CTA_CLASSES = `inline-flex items-center gap-1.5 shrink-0 rounded-full px-4 py-1.5 bg-accent-orange text-white-button-text-color font-bold hover:bg-accent-orange-hovered transition-colors duration-300 ${FOCUS_RING}`;
const CLOSE_BUTTON_CLASSES = `absolute top-1 right-1 md:static md:-my-2 md:-me-2 flex items-center justify-center shrink-0 w-10 h-10 rounded-full text-mid-grey-color hover:text-link-hovered transition-colors duration-300 ${FOCUS_RING}`;

const readDismissed = (storageKey) => {
  try {
    return window.localStorage.getItem(storageKey) === "true";
  } catch {
    return false;
  }
};

const AnnouncementBanner = ({
  message,
  ctaText,
  href,
  storageKey,
  ariaLabel = "Announcement",
  closeLabel = "Dismiss announcement",
}) => {
  const [isDismissed, setIsDismissed] = useState(() =>
    readDismissed(storageKey)
  );

  if (isDismissed) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
    try {
      window.localStorage.setItem(storageKey, "true");
    } catch {
      // Storage blocked (e.g. private mode): stay hidden for this visit only.
    }
  };

  return (
    <section
      aria-label={ariaLabel}
      className="bg-black border-b border-white/10 text-link-unhover"
    >
      {/* On mobile the close button is absolute; px-11 clears it on both sides so the content stays truly centered */}
      <div className="relative flex items-center gap-3 px-11 md:px-20 py-3">
        {/* Spacer mirrors the close button so the content stays centered on desktop */}
        <div className="hidden md:block w-10 shrink-0" aria-hidden="true" />

        <div className="flex-1 min-w-0 flex flex-wrap items-center justify-center gap-x-4 gap-y-2.5 font-medium text-[14px] md:text-[16px] leading-[140%] tracking-[0]">
          <p className="min-w-0 text-center">{message}</p>
          {/* rel="noopener" (without noreferrer) keeps the referrer for attribution */}
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a
            href={href}
            target="_blank"
            rel="noopener"
            className={CTA_CLASSES}
          >
            {ctaText}
            <span aria-hidden="true">→</span>
            <span className="sr-only"> (opens in a new tab)</span>
          </a>
        </div>

        <button
          type="button"
          onClick={handleDismiss}
          aria-label={closeLabel}
          className={CLOSE_BUTTON_CLASSES}
        >
          <X size={20} aria-hidden="true" />
        </button>
      </div>
    </section>
  );
};

export default AnnouncementBanner;
